import { apiClient } from '../_helpers';
const apiPath = 'ingredients/';

export const ingredientService = {
  getIngredientsQuickSearch,
  getIngredients,
  getById,
  addIngredient,
  editIngredient,
  removeIngredient
};

async function getIngredientsQuickSearch(params) {
    try {
      const response = await apiClient(apiPath)
          .post('quicksearch', `${JSON.stringify(params)}`);
          return response.data;
    } catch (error) {
        return error;
    }
}

async function getIngredients(params) {
  var ps = "";
  var ccat = "";
  if(params.query)
  {
    ps = ps + "searchTerm=" + params.query;
    ccat = "&";
  }
  if(params.filter)
  { 
    ps = ps + ccat + "filter=" + params.filter;
    ccat = "&";
  }
  if(params.pageSize)
  { 
    ps = ps + ccat + "pageSize=" + params.pageSize;
    ccat = "&";
  }
  if(params.page)
  {
    ps = ps + ccat + "pageNumber=" + params.page;
    ccat = "&";
  }
  if(params.dataTypes)
  {
    for (var i = 0; i < params.dataTypes.length; i++) { 
      ps = ps + ccat + "dataTypes=" + params.dataTypes[i];
      ccat = "&";
    }
  }
  try {
    const response = await apiClient(`${apiPath}?${ps}`)
        .get();
    return response.data;
  } catch (error) {
    return error;
  }
}

async function getById(id) {
  try {
    const response = await apiClient(`${apiPath}${id}`)
        .get();
    return response.data;
  } catch (error) {
    return error;
  }
}

async function addIngredient(params) {
  try {
      const response = await apiClient(apiPath)
          .post('', `${JSON.stringify(params)}`);
          return response.data;
  } catch (error) {
      return error;
  }
}

async function editIngredient(params) {
  try {
      const response = await apiClient(`${apiPath}${params.id}`)
          .put('', `${JSON.stringify(params)}`);
          return response.data;
  } catch (error) {
      return error;
  }
}

async function removeIngredient(params) {
  try {
      const response = await apiClient(apiPath)
          .delete(`${params}`);
      return response.data;
  } catch (error) {
      return error;
  }
}